import { ADMIN_URLS } from "../../apiConfig.js";
import { SKILL_ERRORS } from "../../../common/constants/adminModule/skillConstants.js";
import apiClient from "../../apiInstance";

export const getUserSkills = async () => {
    try {
        const response = await apiClient.get(ADMIN_URLS.FETCH_SKILLS);
        return response.data;
    } catch (error) {
        console.error(SKILL_ERRORS.FETCH_SKILLS_ERROR, error);
        throw error;
    }
};

export const addUserSkill = async (skillData) => {
    try {
        const response = await apiClient.post(`${ADMIN_URLS.ADD_USER_SKILL}`, skillData, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        return response.data;
    } catch (error) {
        console.error(SKILL_ERRORS.ADD_SKILL_ERROR, error);
        throw error;
    }
};

export const editUserSkill = async (skillData) => {
    try {
        const response = await apiClient.put(`${ADMIN_URLS.UPDATE_USER_SKILL}`, skillData);
        return response.data;
    } catch (error) {
        console.error(SKILL_ERRORS.UPDATE_SKILL_ERROR, error);
        throw error;
    }
};